"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import Image from "next/image";
import { Link } from "@/components/Link/Link.component";
import { useTranslation } from "@/components/Translation/hooks/use-translation.hook";
import { useSiteConfiguration } from "@/contexts/site-configuration/site-configuration.context";
import { tailwindScreenSize } from "@/utilities/ui/get-tailwind-config";
type TopAdFallbackProps = {
  readonly className?: string;
};
export function TopAdFallback(t0) {
  const $ = _c(24);
  const {
    className
  } = t0;
  const {
    id,
    links: t1
  } = useSiteConfiguration();
  const {
    fallbackBanner
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      da: "Annonce",
      de: "Anzeige",
      en: "Advertisement",
      no: "Annonse",
      sv: "Annons"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const label = useTranslation(t2);
  const t3 = `/images/topbanner-fallbacks/${id}_desktop.png`;
  const t4 = `/images/topbanner-fallbacks/${id}_mobile.png`;
  let t5;
  if ($[1] !== t3 || $[2] !== t4) {
    t5 = {
      desktop: t3,
      mobile: t4
    };
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const imgSource = t5;
  if (fallbackBanner === undefined) {
    return null;
  }
  let t6;
  if ($[4] !== className) {
    t6 = clsx(className, "relative", "before:absolute before:-top-2.5 before:left-0 before:select-none before:text-dim before:text-xs before:uppercase before:leading-tight before:content-[attr(data-label)]");
    $[4] = className;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== imgSource.desktop) {
    t7 = <source media={`(min-width: ${tailwindScreenSize.md})`} sizes="930px" srcSet={imgSource.desktop} />;
    $[6] = imgSource.desktop;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== imgSource.mobile) {
    t8 = <source media="(min-width: 0)" srcSet={imgSource.mobile} />;
    $[8] = imgSource.mobile;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== imgSource.mobile || $[11] !== label) {
    t9 = <Image alt={label} className="select-none object-cover" draggable={false} fill={true} priority={true} sizes="320px" src={imgSource.mobile} />;
    $[10] = imgSource.mobile;
    $[11] = label;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t10 = <picture className="relative block h-[160px] w-[320px] lg:h-[180px] lg:w-[930px]">{t7}{t8}{t9}</picture>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== fallbackBanner || $[18] !== t10) {
    t11 = <Link className="block" href={fallbackBanner}>{t10}</Link>;
    $[17] = fallbackBanner;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== label || $[21] !== t11 || $[22] !== t6) {
    t12 = <div className={t6} data-label={label}>{t11}</div>;
    $[20] = label;
    $[21] = t11;
    $[22] = t6;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}